<script>
  import { onMount } from "svelte";
  import axios from "axios";
  import { link } from "svelte-spa-router";
  import Layout from "../../Layout/Layout.svelte";
  import MenuHeading from "../../shared/MenuHeading.svelte";
  import config from "../../stores/config";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import OrderStyles from "./OrderStyles/OrderStyles.svelte";
  let loading = true;

  export let params;
  const { id } = params;

  let order = null;

  let authData = { headers: { authorization: ls.get("jwt") } };

  const loadData = async () => {
    loading = true;

    axios
      .get(`${$config.backendURL}/orders/${id}`, authData)
      .then((res) => {
        order = res.data;
        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onMount(async () => {
    loadData();
  });

  const handleCloseOrder = () => {
    const confirmed = confirm(`Close?`);
    if (!confirmed) return;

    axios
      .put(
        `${$config.backendURL}/orders/${id}`,
        { completed: true, completedOn: new Date().toISOString() },
        authData
      )
      .then((res) => loadData())
      .catch((err) => console.log(err));
  };

  const handleReopenOrder = () => {
    const confirmed = confirm(`Reopen?`);
    if (!confirmed) return;

    axios
      .put(
        `${$config.backendURL}/orders/${id}`,
        { completed: false, completedOn: new Date().toISOString() },
        authData
      )
      .then((res) => loadData())
      .catch((err) => console.log(err));
  };
</script>

<svelte:head>
  <title>Job Card Details — Supreme Upholstery System</title>
</svelte:head>

<Layout>
  <div class="py-2" />

  {#if loading}
    <div class="loading-screen h-screen flex items-center justify-center">
      <Wave size="100" color="rgb(244,162,97)" unit="px" />
    </div>
  {:else}
    <div class="flex justify-between">

      <div class="flex justify-end mb-6">
        {#if order.completed}
          <button
            class="btn btn-primary-outline whitespace-nowrap"
            on:click={handleReopenOrder}
          >
            <i class="fas fa-check-circle mr-3" />
            Reopen Card
          </button>
        {:else}
          <button
            class="ml-3 btn btn-red-outline whitespace-nowrap"
            on:click={handleCloseOrder}
          >
            <i class="fas fa-times-circle mr-3" />
            Close Card
          </button>
        {/if}
        <a
          class="ml-3 btn btn-green-outline whitespace-nowrap"
          use:link
          href={`/customers/${order.customerID}`}
        >
          <i class="fas fa-eye mr-3" />
          View Customer
        </a>
        <a
          class="ml-3 btn btn-primary-outline whitespace-nowrap"
          use:link
          href="/orders"
        >
          <i class="fas fa-arrow-left mr-3" />
          Return to Job Cards
        </a>
      </div>
    </div>

    <!-- MANAGE STYLES HERE -->
    <div class="-mt-6">
      <MenuHeading
        title={`Job Card #${order.orderID}`}
        description="Add/Edit Job Card Content"
      />
    </div>

    <OrderStyles
      orderID={order._id}
      orderStyles={order.items}
      orderNumber={order.orderID}
      dateOrdered={order.dateOrdered}
      on:reloadData={() => loadData()}
    />
  {/if}
</Layout>
